import { errorEvents } from "@/lib/error-events";

export async function handleApiErrorResponse(response: Response, contextMessage: string) {
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.includes("application/json")) {
        const errorData = await response.json();
        throw new Error(errorData.message || contextMessage);
    }
    throw new Error(`${contextMessage} ${response.status} ${response.statusText}`);
}

export function handleApiThrowError(error, contextMessage: string, header:string) {
    console.log(error)
    console.error('Error fetching orders:', error);
    const message = error.message || contextMessage;
    errorEvents.emit(message, header);

    throw error;
}